import React, { ReactNode } from 'react';
import styled from '@emotion/styled';

const GridItemLayout = styled.div`
  // Fixed width necessary
  // for Masonry layout
  width: 29.125rem;
  margin-bottom: 1.5rem;
`;

interface Props {
  children: ReactNode;
}

export const GridItem = (props: Props) => {
  return <GridItemLayout>{props.children}</GridItemLayout>;
};
